import React, { ReactElement } from 'react';
import theme from './ProfileAndUserDisplay.module.scss';
import { ProfileIcon, UserIcon } from '@/components/Icons';

interface ProfileAndUserDisplayProps {
    profileName?: string;
    profileId?: number;
    userName?: string;
    userId?: number;
    showUserAvatar?: boolean;
    icons?: 'auto' | 'user' | 'profile' | 'both';
    mode?: 'user' | 'profile';
    prependContent?: ReactElement;
    appendContent?: ReactElement;
}

const ProfileAndUserDisplay: React.FC<ProfileAndUserDisplayProps> = ({
    profileId,
    profileName,
    userId,
    userName,
    icons = 'auto',
    mode = 'profile',
    prependContent,
    appendContent,
}) => {
    const shouldShowIcon = (type: 'user' | 'profile') => {
        return (mode === type && icons === 'auto') || icons === type || icons === 'both';
    };

    const textElement =
        mode === 'profile' ? (
            <span className={theme.text}>
                {profileName} {userName && <small>{userName}</small>}
            </span>
        ) : (
            <span className={theme.text}>
                {userName} {profileName && <small>{profileName}</small>}
            </span>
        );

    return (
        <div className={theme.container}>
            {profileId && shouldShowIcon('profile') && <ProfileIcon profileId={profileId} sizeInPx={32} />}
            {userId && shouldShowIcon('user') && <UserIcon userId={userId} sizeInPx={32} />}

            <span>
                {prependContent}
                {textElement}
                {appendContent}
            </span>
        </div>
    );
};

export default ProfileAndUserDisplay;
